/**
 * @author HungNS
 */
import DashboardService from './modules/DashboardService';
import NewsService from './modules/NewsService';
import DepositService from './modules/DepositService';
import ReportService from './modules/ReportService';
import WithdrawalService from './modules/WithdrawalService';
import BankAccountService from "./modules/BankAccountService";
import ForceNewsService from './modules/ForceNewsService'
import TransferService from './modules/TransferService';
import CryptoRegistrationService from "./modules/CryptoRegistrationService";
import BoRegistrationService from "./modules/BoRegistrationService";
import BoTestService from "./modules/BoTestService";
import ProfileService from "./modules/ProfileService";
import AuthService from "./modules/AuthService";
import HistoryService from "@/services/modules/HistoryService";
import FidoService from "@/services/modules/FidoService";

export default {
    dashboard: DashboardService,
    news: NewsService,
    deposit: DepositService,
    withdrawal: WithdrawalService,
    bankAccount: BankAccountService,
    forceNews: ForceNewsService,
    transfer: TransferService,
    report: ReportService,
    cryptoRegistration: CryptoRegistrationService,
    boRegistration: BoRegistrationService,
    boTest: BoTestService,
    profile: ProfileService,
    auth : AuthService,
    history: HistoryService,
    fido: FidoService
}
